import { render, staticRenderFns } from "./TeleMarketUserEfficiency.vue?vue&type=template&id=718bc7aa"
import script from "./TeleMarketUserEfficiency.vue?vue&type=script&lang=js"
export * from "./TeleMarketUserEfficiency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports